<div class="title">
    {{ "widget_product_settings_general" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setThemeBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">
            {{ "control_radius" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                prefixImgUrl="./assets/img/border-radius-icon.svg"
                suffixText="px"
                [min]="BORDER_RADIUS_MIN"
                [max]="BORDER_RADIUS_MAX"
                [onlyIntegers]="true"
                [value]="borderRadius.value"
                (valueChange)="setBorderRadius($event)"
                (blurEvent)="setBorderRadius($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-20" [class.mb-10]="isBorder.value" [class.mb-20]="!isBorder.value">
        <label class="col-xs-9 control-label">
            {{ "control_contour" | translate }}
        </label>
        <div class="col-xs-3 text-right">
            <sp-switch [control]="isBorder"></sp-switch>
        </div>
    </div>

    @if (isBorder.value) {
        <div class="form-group mb-20">
            <div class="col-xs-4">
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [onlyIntegers]="true"
                    [value]="+borderWidth.value"
                    (valueChange)="setBorderWidth($event)"
                ></sp-input-num>
            </div>
            <div class="col-xs-5">
                <select class="form-control" [formControl]="borderStyle">
                    <option [ngValue]="lineStyle.SOLID">{{ "control_solid" | translate }}</option>
                    <option [ngValue]="lineStyle.DASHED">{{ "control_dashed" | translate }}</option>
                    <option [ngValue]="lineStyle.DOTTED">{{ "control_dotted" | translate }}</option>
                </select>
            </div>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="borderColor.value?.toString()"
                    (colorChangeEvent)="setBorderColor($event)"
                    [hideGradient]="true"
                ></sp-color-picker>
            </div>
        </div>
    }

    <div class="form-group mb-10">
        <label class="col-xs-6">
            {{ "control_padding" | translate }}
        </label>
        <div class="col-xs-6 text-right">
            <div class="preset-padding-buttons">
                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">0</button>
                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(15)">15</button>
                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(30)">30</button>
            </div>
        </div>
    </div>

    <div class="form-group mb-0">
        <div class="col-xs-12 d-flex">
            <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [onlyIntegers]="true"
                    [value]="+paddingLeft.value"
                    (valueChange)="setPaddingLeft($event)"
                ></sp-input-num>
            </div>
            <div style="flex-grow: 1">
                <div class="mb-10">
                    <sp-input-num
                        suffixText="px"
                        [min]="SIZE_MIN"
                        [max]="SIZE_MAX"
                        [onlyIntegers]="true"
                        [value]="+paddingTop.value"
                        (valueChange)="setPaddingTop($event)"
                    ></sp-input-num>
                </div>
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [onlyIntegers]="true"
                    [value]="+paddingBottom.value"
                    (valueChange)="setPaddingBottom($event)"
                ></sp-input-num>
            </div>
            <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [onlyIntegers]="true"
                    [value]="+paddingRight.value"
                    (valueChange)="setPaddingRight($event)"
                ></sp-input-num>
            </div>
        </div>
    </div>

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
